<template>
  <div class="month-foot-card">
    <div>
      本月校园心理健康数据报告已全面呈现我校心理工作的推进成效与学生心理状态的趋势，印证了我校心理健康教育体系的扎实落地。这份成绩的背后，离不开学校对心理健康工作的高度重视，为学生构建了心理健康的
      “防护网”，充分彰显了我校 “以生为本” 的教育理念与责任担当。
    </div>
    <div>
      心灵的滋养需要耐心浇灌，成长的路上难免有风雨相伴，愿我们继续以爱为基、以智为翼，守护每一颗年轻心灵的澄澈与坚韧，让每一位学生都能在健康阳光的校园环境中，自信前行、向阳生长。
    </div>
  </div>
</template>
<script>
export default {
  name: 'FootCard',
}
</script>

<style scoped lang="less">
.month-foot-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  height: 220px;
  padding: 20px;
  border-radius: 20px;
  background: #fff url('~@assets/imgs/school/monthRecord/monthRecordFootBg.jpg') no-repeat;
  background-size: 100% 100%;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 43px;
  color: #40689c;
  text-indent: 2em;
}
</style>
